import React from 'react'

import { VerifierType } from '@frame/lib/api/common/types'
import { useStore } from '@frame/lib/stores/useStore'
import { DataAttribute } from '@frame/types'

import { MortgageBankContent } from './mortgage-bank-content'
import { TenantBankContent } from './tenant-bank-content'

export function BankInstructionsCard() {
  const { verifierType } = useStore((state) => ({
    verifierType: state.session?.verifier_type,
  }))
  const isTenantVerifier = verifierType === VerifierType.TENANT
  return (
    <div
      data-cy={DataAttribute.BANK_INSTRUCTIONS}
      className="flex flex-col space-y-3 rounded-md border-[2px] border-moss-200 p-3 pl-4"
    >
      {isTenantVerifier ? <TenantBankContent /> : <MortgageBankContent />}
    </div>
  )
}
